import Block, { BlockTypes } from './Block';
function hasEmptyLineFormat(line) {
    return line === '' || line === ' ';
}
function hasSceneHeadingFormat(line) {
    return null !== line.match(/^((int|ext|i\/e)([. ])|\.\w)/i);
}
function hasParentheticalFormat(line) {
    return null !== line.match(/^(\(.+\))$/);
}
export function parseImage(line) {
    var _a;
    const match = line.match(/^!(.+)!#(.*)?#$/);
    if (!match) {
        return null;
    }
    return {
        path: match[1],
        caption: (_a = match[2]) !== null && _a !== void 0 ? _a : '',
    };
}
function hasCharacterFormat(line) {
    const match = line.match(/^@?([\w\u00C0-\u017F.]{1,})/); // first letter is @ or character
    if (match && (line.startsWith('@') || line === line.toUpperCase())) {
        return true;
    }
    return false;
}
export default function getBlockType(line, typeBefore, nextLine) {
    if (hasEmptyLineFormat(line)) {
        return BlockTypes.Empty;
    }
    if (line.startsWith('~')) {
        return BlockTypes.Lyrics;
    }
    if (line === '===') {
        return BlockTypes.PageBreak;
    }
    if (line.startsWith('=')) {
        return BlockTypes.Synopsis;
    }
    if (line.startsWith('# ')) {
        return BlockTypes.Header1;
    }
    if (line.startsWith('## ')) {
        return BlockTypes.Header2;
    }
    if (line.startsWith('### ')) {
        return BlockTypes.Header3;
    }
    if (line.startsWith('#### ')) {
        return BlockTypes.Header4;
    }
    if (line.startsWith('##### ')) {
        return BlockTypes.Header5;
    }
    if (line.startsWith('###### ')) {
        return BlockTypes.Header6;
    }
    if (!line.startsWith('!')) {
        // Scene Heading
        if ((!typeBefore || typeBefore === BlockTypes.Empty) && (!nextLine || hasEmptyLineFormat(nextLine))) {
            if (hasSceneHeadingFormat(line)) {
                return BlockTypes.SceneHeading;
            }
        }
        // Parenthetical
        if (typeBefore === BlockTypes.Character || typeBefore === BlockTypes.Dialogue) {
            if (hasParentheticalFormat(line)) {
                return BlockTypes.Parenthetical;
            }
        }
        // Dialogue
        if (typeBefore === BlockTypes.Character || typeBefore === BlockTypes.Parenthetical) {
            return BlockTypes.Dialogue;
        }
        if (typeBefore === BlockTypes.Dialogue && line !== '') {
            return BlockTypes.Dialogue;
        }
        // Centered
        if (line.startsWith('>') && line.endsWith('<')) {
            return BlockTypes.CenteredAction;
        }
        let match;
        // Transition
        match = line.match(/^((?:FADE (?:TO BLACK|OUT)|CUT TO BLACK)\.|.+ TO:)|^(?:> *)(.+)/);
        if (match) {
            return BlockTypes.Transition;
        }
        // Character
        if ((!typeBefore || typeBefore === BlockTypes.Empty) && (nextLine && !hasEmptyLineFormat(nextLine))) {
            if (hasCharacterFormat(line)) {
                return BlockTypes.Character;
            }
        }
    }
    else {
        const image = parseImage(line);
        if (image) {
            return BlockTypes.Image;
        }
    }
    return BlockTypes.Action;
}
export function getBlocks(fountain, idManager) {
    const blocks = [];
    const lines = fountain.split(/\r?\n/);
    let lastBlockType = undefined;
    lines.forEach((line, index) => {
        const blockType = getBlockType(line, lastBlockType, lines[index + 1]);
        blocks.push(new Block(idManager.getNextId(), blockType, line));
        lastBlockType = blockType;
    });
    return blocks;
}
export function getPreviewBlocks(fountain, idManager) {
    const blocks = getBlocks(fountain, idManager);
    const previewBlocks = [];
    let previousBlockWasRemoved = false;
    for (const block of blocks) {
        const text = block.getText();
        if (previousBlockWasRemoved) {
            previousBlockWasRemoved = false;
            if (hasEmptyLineFormat(text)) {
                previousBlockWasRemoved = false;
                continue;
            }
        }
        if (text.startsWith('[[') && text.endsWith(']]')) {
            previousBlockWasRemoved = true;
            continue;
        }
        if ([BlockTypes.Header1, BlockTypes.Header2, BlockTypes.Header3, BlockTypes.Header4, BlockTypes.Header5, BlockTypes.Header6, BlockTypes.Synopsis].indexOf(block.getType()) !== -1) {
            previousBlockWasRemoved = true;
            continue;
        }
        previewBlocks.push(block);
    }
    return previewBlocks;
}
